import {styled} from '@mui/material'
import {useIsMobile} from 'services/hooks/use-mobile'

export const FormRow = ({children, alignItems = 'start'}) => {
    const isMobile = useIsMobile()
    if (isMobile) {
        return <>{children}</>
    }
    return <StyledFormRow alignItems={alignItems}>{children}</StyledFormRow>
}
export const StyledFormRow = styled('div')`
    display: flex;
    justify-content: space-between;
    align-items: ${({alignItems}) => alignItems};
    gap: 12px;
`
